module.exports = __webpack_public_path__ + "img/symbol_12.b8a81f3d.png";